"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = require("lodash");

var types = _interopRequireWildcard(require("./types"));

var tagTypesTypes = _interopRequireWildcard(require("../tagType/types"));

var _tagHelper = require("../util/tagHelper");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    tags: [],
    tagsHierarchy: [],
    isFetchingTag: false,
    isEditingTag: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case types.TAG_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTag: true,
        tags: [],
        tagsHierarchy: []
      });

    case types.TAG_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTag: false,
        tags: action.tags ? action.tags : state.tags,
        tagsHierarchy: action.tagsHierarchy ? action.tagsHierarchy : state.tagsHierarchy
      });

    case types.TAG_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTag: false
      });

    case tagTypesTypes.TAG_ADD_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        // need a deep copy in order for prop updates to take place in components
        tagsHierarchy: (0, _lodash.clone)((0, _tagHelper.addTagToTagsHierarchicalList)(state.tagsHierarchy, action.newTag), true),
        tags: state.tags.concat([action.newTag])
      });

    case types.TAG_EDIT_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isEditingTag: true
      });

    case types.TAG_EDIT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isEditingTag: false,
        tags: state.tags.map(function (t) {
          if (t.id === action.updatedTag.id) {
            return action.updatedTag;
          }

          return t;
        }),
        // need a deep copy in order for prop updates to take place in components
        tagsHierarchy: (0, _lodash.clone)((0, _tagHelper.updateTagInTagsHierarchicalList)(state.tagsHierarchy, action.updatedTag, true), true)
      });

    case types.TAGS_EDIT_SUCCESS:
      //eslint-disable-line
      var newFlatListOfTags = state.tags;
      (0, _lodash.forEach)(action.updatedTags, function (updatedTag) {
        newFlatListOfTags.map(function (t) {
          if (t.id === updatedTag.id) {
            return updatedTag;
          }

          return t;
        });
      });
      (0, _lodash.forEach)(action.updatedTags, function (updatedTag) {
        return (0, _tagHelper.updateTagInTagsHierarchicalList)(state.tagsHierarchy, updatedTag, true);
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        isEditingTag: false,
        // need a deep copy in order for prop updates to take place in components
        tagsHierarchy: (0, _lodash.clone)(state.tagsHierarchy, true),
        tags: newFlatListOfTags
      });

    case types.TAG_EDIT_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isEditingTag: false
      });

    default:
      return state;
  }
};

exports["default"] = _default;